// @ts-nocheck
import React from 'react'
import DistributionSVG from 'images/illustrations/distribution'
import DistributionHighSVG from 'images/illustrations/distribution-high'
import cx from 'classnames'
import { t } from 'ttag'
import styles from './BellCurve.module.scss'

const stepClasses = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
]

export const BellCurve = ({
  allScores,
  selectedCandidates,
  hideScore = false,
  high = false,
  className = undefined,
  single,
  candidates,
}) => {
  const scores = allScores.filter(
    score => single || selectedCandidates?.[score.id],
  )

  const sameStep =
    allScores.length === 2 &&
    Math.min(Math.floor(allScores[0].score / 10), 9) -
      Math.min(Math.floor(allScores[1].score / 10), 9) ===
      0

  return (
    <div
      className={cx(
        styles.distributionSVG,
        ...scores.map(score => {
          const stepClassName =
            stepClasses[Math.min(Math.floor(score.score / 10), 9)]

          return styles[
            candidates.findIndex(cand => cand.id === score.id)
              ? stepClassName + 2
              : stepClassName
          ]
        }),
        {
          [className]: Boolean(className),
          [styles.isDouble]: !single,
          [styles.sameStep]: sameStep,
          [styles.bothSelected]: scores.length === 2,
        },
      )}
    >
      {hideScore
        ? null
        : scores.map((score, index) => {
            if (isNaN(score.score)) {
              return null
            }

            return (
              <div
                key={index}
                className={cx(
                  candidates.findIndex(cand => cand.id === score.id)
                    ? styles.label2
                    : styles.label,
                  {
                    [styles.high]: high,
                    [styles.isDouble]: !single,
                    [styles.sameStep]: sameStep,
                  },
                )}
              >
                {Math.round(score.score)}
              </div>
            )
          })}
      {high ? <DistributionHighSVG /> : <DistributionSVG />}
      <div className={cx(styles.axis, { [styles.high]: high })}>
        <div>0</div>
        <div>100</div>
      </div>

      <div
        className={cx(styles.averageArea, {
          [styles.high]: Boolean(high),
        })}
      >
        <div className={cx(styles.dottedArea, styles.dottedAreaLeft)} />
        <div className={styles.averageAreaLabel}>{t`Average`}</div>
        <div className={cx(styles.dottedArea, styles.dottedAreaRight)} />
      </div>
    </div>
  )
}
